export interface Exercise {
    name: string;
    description?: string;
    mediaUrl?: string;
    skipped?: boolean;
    done?: boolean;
    metrics?: {
      concentric?: { value: number; change: number };
      eccentric?: { value: number; change: number };
      reps?: { value: number; change: number };
      time?: { value: number; change: number };
      speed?: 'slow' | 'normal' | 'fast';
      wat?: { value: number; change: number };
      kilometry?: { value: number; change: number };
      delta?: { value: number; change: number };
      puls?: { value: number; change: number };
    };
  }
  
  const YT = 'https://www.youtube.com/watch?v=t_hM_5sjdMo';
  const M36 = 'https://36minut.pl/trening-36-minut/'
  
  export const DESC: Record<string, { d: string; url?: string }> = {
    'LEG EXTENSION': {
      d: 'Ćwiczenie izolowane na przednią część ud. Pozwala bezpiecznie zwiększać siłę i wytrzymałość czworogłowego. Utrzymuj stopy równolegle, aby chronić stawy kolanowe.',
      url: YT,
    },
    'CHEST PRESS': {
      d: 'Maszyna symuluje wyciskanie sztangi na ławce. Pracuje głównie klatka piersiowa oraz tricepsy. Prowadnica stabilizuje ruch, dzięki czemu łatwiej skupić się na napięciu mięśni.',
      url: M36,
    },
    'SEATED ROW': {
      d: 'Wiosłowanie siedząc angażuje mięśnie grzbietu i bicepsy. Ściągaj łopatki, utrzymuj prosty kręgosłup. Kontroluj ciężar w fazie negatywnej.',
      url: YT,
    },
    'LEG CURL': {
      d: 'Uginanie nóg w leżeniu koncentruje pracę na mięśniach dwugłowych uda. Zachowaj spokojne tempo, unikaj przeprostu bioder. Ćwiczenie redukuje dysproporcje przednia-tylna część uda.',
      url: YT,
    },
    'ERGOMETR': {
      d: 'Ergometr wioślarski to trening całego ciała o niskim impakcie. Poprawia wydolność, mobilizuje niemal wszystkie grupy mięśni. Utrzymuj równy rytm oddechowy.',
      url: M36,
    },
    'ABDOMINAL CRUNCH': {
      d: 'Brzuszki na maszynie izolują mięsień prosty brzucha. Nie szarp ciężaru, skup się na wydechu w szczytowym napięciu. Idealne uzupełnienie ćwiczeń funkcjonalnych core.',
      url: YT,
    },
    'BACK EXTENSION': {
      d: 'Prostowniki grzbietu wzmacniają odcinek lędźwiowy. Zatrzymaj ruch w pozycji neutralnej – nie odchylaj się za mocno. Zapobiega kontuzjom dolnych pleców.',
      url: M36,
    },
    'CROSSWALKER': {
      d: 'Orbitrek generuje dynamiczny ruch angażujący nogi i górę ciała. Minimalizuje obciążenie stawów. Ustal opór tak, by zachować prawidłową technikę przez cały czas.',
      url: YT,
    },
    'POMPKI': {
      d: 'Klasyczne pompki rozwijają klatkę piersiową, barki i tricepsy. Trzymaj ciało w jednej linii i schodź klatką poniżej poziomu łokci.',
      url: 'https://36minut.pl/trening-ems/',
    },
    'BRZUSZKI': {
      d: 'Tradycyjne brzuszki wzmacniają mięśnie proste brzucha. Unikaj ciągnięcia szyi rękami; wykonuj płynny ruch kręgosłupa.',
      url: 'https://36minut.pl/trening-personalny/',
    },
    'PIŁKA': {
      d: 'Ćwiczenia z piłką gimnastyczną poprawiają równowagę i aktywują mięśnie stabilizujące. Wybierz piłkę dobraną do swojego wzrostu.',
      url: 'https://36minut.pl/masaz-rehabilitacja-trening-medyczny/',
    },
    'BIEGANIE': {
      d: 'Bieg w miejscu lub na bieżni zwiększa wytrzymałość sercowo-naczyniową. Kontroluj kadencję oraz technikę lądowania stopy.',
      url: 'https://36minut.pl/trening-36-minut/',
    },
    'JOGA': {
      d: 'Krótkie ćwiczenie poprawia elastyczność i koncentrację. Skup się na płynnym oddechu i świadomym ustawieniu miednicy.',
      url: 'https://www.youtube.com/watch?v=agg6R5qQS5k',
    },
    'ROZCIĄGANIE': {
      d: 'Całościowy stretching zwiększa zakres ruchu i przyspiesza regenerację. Zatrzymaj każdą pozycję na co najmniej 20 sekund przy spokojnym oddechu.',
      url: 'https://www.youtube.com/watch?v=_B4EudJIenA',
    },
    'PRZYSIADY': {
      d: 'Przysiady z ciężarem własnym aktywują największe grupy mięśniowe. Trzymaj kolana w linii stóp, unikaj "zapadania" kostek.',
      url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    },
  };
  
  export const BASE_NAMES = [
    'LEG EXTENSION',
    'CHEST PRESS',
    'SEATED ROW',
    'LEG CURL',
    'ERGOMETR',
    'ABDOMINAL CRUNCH',
    'BACK EXTENSION',
    'CROSSWALKER',
  ];
  
  const BASE_EX = BASE_NAMES.map((n) => ({ 
    name: n, 
    ...DESC[n],
    metrics: generateRandomMetrics()
  }));
  const EXTRA_NAMES = Object.keys(DESC).filter((n) => !BASE_NAMES.includes(n));
  
  function generateRandomMetrics() {
    const metrics: Exercise['metrics'] = {};
    
    const allMetricTypes = ['concentric', 'eccentric', 'reps', 'time', 'wat', 'kilometry', 'delta', 'puls'];
    const selectedTypes = [];
    
    selectedTypes.push('reps');
    
    const shuffled = [...allMetricTypes.filter(t => t !== 'reps')].sort(() => 0.5 - Math.random());
    const maxAdditional = Math.min(5, Math.floor(1 + Math.random() * 5)); // Maximum 5 additional metrics
    const additional = shuffled.slice(0, maxAdditional);
    selectedTypes.push(...additional);
    
    if (selectedTypes.includes('concentric')) {
      const value = 10 + Math.floor(Math.random() * 7) * 5;
      const change = Math.floor(Math.random() * 5) - 2;
      metrics.concentric = { value, change };
    }
    
    if (selectedTypes.includes('eccentric')) {
      const value = 10 + Math.floor(Math.random() * 7) * 5;
      const change = Math.floor(Math.random() * 5) - 2;
      metrics.eccentric = { value, change };
    }
    
    if (selectedTypes.includes('reps')) {
      const value = 6 + Math.floor(Math.random() * 10);
      const change = Math.floor(Math.random() * 5) - 2;
      metrics.reps = { value, change };
    }
    
    if (selectedTypes.includes('time')) {
      const value = 1 + Math.floor(Math.random() * 5);
      const change = Math.floor(Math.random() * 3) - 1;
      metrics.time = { value, change };
    }
    
    if (selectedTypes.includes('wat')) {
      const value = 50 + Math.floor(Math.random() * 12) * 5;
      const change = Math.floor(Math.random() * 5) - 2;
      metrics.wat = { value, change };
    }
    
    if (selectedTypes.includes('kilometry')) {
      const value = Math.floor(10 + Math.random() * 40) / 10;
      const change = (Math.floor(Math.random() * 10) - 5) / 10;
      metrics.kilometry = { value, change };
    }
    
    if (selectedTypes.includes('delta')) {
      const value = 5 + Math.floor(Math.random() * 20);
      const change = Math.floor(Math.random() * 11) - 5;
      metrics.delta = { value, change };
    }
    
    if (selectedTypes.includes('puls')) {
      const value = 110 + Math.floor(Math.random() * 70);
      const change = Math.floor(Math.random() * 21) - 10;
      metrics.puls = { value, change };
    }
    
    if (Object.keys(metrics).length <= 5 && Math.random() > 0.7) {
      const speeds = ['slow', 'normal', 'fast'] as const;
      metrics.speed = speeds[Math.floor(Math.random() * speeds.length)];
    }
    
    return metrics;
  }
  
  const pickExtras = (n: number) => {
    const out: Exercise[] = [];
    while (out.length < n) {
      const name = EXTRA_NAMES[Math.floor(Math.random() * EXTRA_NAMES.length)];
      if (!out.find((e) => e.name === name)) {
        out.push({ 
          name, 
          ...DESC[name],
          metrics: generateRandomMetrics()
        });
      }
    }
    return out;
  };
  
  export interface TrainingSession {
    id: string;
    title: string;
    description: string;
    exercises: Exercise[];
    durationMinutes: number;
  }
  
  export interface TrainingPlan {
    id: string;
    name: string;
    subtitle: string;
    description: string;
    sessions: TrainingSession[];
    started: boolean;
    finished: boolean;
    completedSessions?: Record<string, Date>;
  }

  const genSessions = (prefix: string): TrainingSession[] =>
    Array.from({ length: 10 }, (_, i) => ({
      id: `${prefix}-session-${i + 1}`,
      title: `Sesja ${i + 1}`,
      description: '',
      exercises: [
        ...BASE_EX.map((e) => ({ ...e, metrics: {...e.metrics} })),
        ...pickExtras(Math.floor(Math.random() * 4)),
      ],
      durationMinutes: 30 + Math.floor(Math.random() * 31),
    }));
  
  const range = (ses: TrainingSession[]) => {
    const obj: Record<string, Date> = {};
    const now = Date.now();
    ses.forEach((s, i) => (obj[s.id] = new Date(now - (ses.length - i + 2) * 864e5)));
    return obj;
  };
  
  const active = genSessions('sila');
  const hist1 = genSessions('schud');
  const hist2 = genSessions('mobil');
  
  export const MOCK_TRAINING_PLANS: TrainingPlan[] = [
    {
      id: 'plan-sila',
      name: 'Siła Podstawowa',
      subtitle: 'BUDOWANIE SIŁY',
      description: '',
      sessions: active,
      started: true,
      finished: false,
    },
    {
      id: 'plan-schud',
      name: 'Schudnięcie Początkujący',
      subtitle: 'REDUKCJA WAGI',
      description: '',
      sessions: hist1,
      started: true,
      finished: true,
      completedSessions: range(hist1),
    },
    {
      id: 'plan-mobil',
      name: 'Mobilność i Stretching',
      subtitle: 'ZDROWIE STAWÓW',
      description: '',
      sessions: hist2,
      started: true,
      finished: true,
      completedSessions: range(hist2),
    },
  ];
  